var Accordion = {

  init:function () {
    $('.js-acdn-content').css({'display':'none'});
    this.click();
  },

  click: function() {
    $('.js-acdn-btn').on('click',function(){
      $(this).toggleClass('is-open');
      $(this).next('.js-acdn-content').slideToggle('is-open');
    });
  }
};

module.exports = Accordion;


//////////////////
// WEBPACK FOOTER
// ./htdocs_dev/_script/components/pagemodules/_accordion.js
// module id = 16
// module chunks = 0